import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {APIClient} from "../../../helpers/ApiHelper";


export const getFilteredDevice = createAsyncThunk(
    "getFilteredDevice",
    async ({ gender, generations, userStatus, purchasingPowers, personas }) => {
        try {
            const apiClient = new APIClient();
            const queryParams = {};

            if (gender !== null) {
                queryParams.gender = gender;
            }

            if (generations.length !== 0) {
                queryParams.generations = generations.join(',');
            }

            if (userStatus !== null) {
                queryParams.userStatus = userStatus;
            }

            if (purchasingPowers.length !== 0) {
                queryParams.purchasingPowers = purchasingPowers.join(',');
            }

            if (personas.length !== 0) {
                queryParams.personas = personas.join(',');
            }

            const response = await apiClient.get("/api/v1/information/device-list", queryParams);

            return response.data;
        } catch (error) {
            throw error;
        }
    }
);



// export const getFilteredDevice = createAsyncThunk(
//     "getFilteredDevice",
//     async ({ gender, generations, userStatus, purchasingPowers, personas }) => {
//
//         const storedUser = sessionStorage.getItem('authUser');
//         const userData = JSON.parse(storedUser);
//         const queryParams = {};
//
//         if (gender !== null) {
//             queryParams.gender = gender;
//         }
//
//         if (generations.length !== 0) {
//             queryParams.generations = generations.join(',');
//         }
//
//         if (userStatus !== null) {
//             queryParams.userStatus = userStatus;
//         }
//
//         if (purchasingPowers.length !== 0) {
//             queryParams.purchasingPowers = purchasingPowers.join(',');
//         }
//
//         if (personas.length !== 0) {
//             queryParams.personas = personas.join(',');
//         }
//
//
//         try {
//             const response = await axios.get(
//                 `/api/information/device/list`,
//                 {
//                     params: queryParams,
//
//                 headers: {
//                     Authorization: `Bearer ${userData.data.accessToken}`,
//                 },
//
//                 }
//             );
//
//
//             return response.data;
//         } catch (error) {
//             throw error;
//         }
//     }
// );


export const filterDeviceSlice = createSlice({
    name: "FilterDeviceSlice",
    initialState: {
        loading: false,
        payload: {},
        items: [],
        totalCount:0
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFilteredDevice.pending, (state) => {
                state.loading = true;
            })
            .addCase(getFilteredDevice.fulfilled, (state, action) => {
                state.loading = false;
                state.payload = action.payload;
                state.items = action.payload.items
                state.totalCount = action.payload.totalUserCount
            })
            .addCase(getFilteredDevice.rejected, (state) => {
                state.loading = false;
                state.items = []
            });
    },
});


export default filterDeviceSlice.reducer;
